import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { layout } from 'styled-system';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  ", ";\n"], ["\n  position: relative;\n  overflow: hidden;\n  ", ";\n"])), layout);
var templateObject_1;
